module.exports = __webpack_public_path__ + "static/media/injuredQuestion.5467192f.mp3";